export default __webpack_public_path__ + "static/media/map.16a99864.png";